import React from 'react';
import { useHistory } from 'react-router-dom';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { ensureUser } from '../../util/data';
import { pathByRouteName } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { FavoriteButton } from '../../components';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, isFavorited, isFavoriteLoading, onToggleFavorite, currentUser, favoriteButtonRef } = props;
  const images = listing.images;
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();

  // Check if listing is from promoted user
  const author = ensureUser(listing.author);
  const isPromotedUser = author?.id?.uuid === process.env.REACT_APP_PROMOTED_USER;

  const handleFavoriteClick = () => {
    if (!currentUser) {
      sessionStorage.setItem('pendingWishlistId', listing.id.uuid);
      const loginPath = pathByRouteName('LoginPage', routeConfiguration);
      history.push(loginPath, { from: `${history.location.pathname}${history.location.search}` });
      return;
    }
    onToggleFavorite(listing.id.uuid);
  };

  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = ['default'];
  // const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <div className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        isPromotedUser={isPromotedUser}
      />
      <div className={css.favoriteButtonContainer}>
        <FavoriteButton
          ref={favoriteButtonRef}
          className={css.favoriteButton}
          isFavorited={isFavorited}
          isLoading={isFavoriteLoading}
          onClick={handleFavoriteClick}
        />
      </div>
    </div>
  );
};

export default SectionGallery;
